<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-align-top`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 6c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h38c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H5zm7 36a1 1 0 01-1-1V15a1 1 0 011-1h8a1 1 0 011 1v26a1 1 0 01-1 1h-8zm15-11a1 1 0 001 1h8a1 1 0 001-1V15a1 1 0 00-1-1h-8a1 1 0 00-1 1v16z"/></svg>
</template>
<script>

export default {
  name: 'IconAlignTop',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
